define('evicommon/spf/sort.adapter',['require','exports','module','../state/param.adapter','./model/sort'],function(require, exports, module){
  var ParamAdapter = require('../state/param.adapter');
  var Sort = require('./model/sort');

  var SortAdapter = ParamAdapter.extend({

    options: {
      sortField: 'sort'
    },

    constructor: function(sortModelOrCollection, options) {
      // sort must be a collection or a single model
      this.sortCollection = !(sortModelOrCollection instanceof Backbone.Collection)
          // if the sort object is not a collection then treat it as a model
          ? new Sort.Collection([sortModelOrCollection])
          : sortModelOrCollection;

      ParamAdapter.call(this, {}, options);
      this.syncSort();
      this.sortCollection.on('add remove change reset', this.syncSort, this);
    },

    syncSort: function() {
      this.model.set(this.options.sortField, this.serializeSortCollection(this.sortCollection));
    },

    serializeSortCollection: function(sortCollection) {
      return sortCollection.toQuery();
    }

  });

  module.exports = SortAdapter;
});
